import { Card } from "@/components/Common";

export const Block = ({ icon: Icon, title, children, testid, accent }) => (
  <Card testid={testid} accent={accent}>
    <div className="mb-3 flex items-center gap-2">
      <Icon size={17} className="text-[#B39257]" />
      <h3 className="font-serif text-xl font-semibold text-[#0D2517]">{title}</h3>
    </div>
    {children}
  </Card>
);

export const List = ({ items }) => <ul className="list-disc space-y-1.5 pl-5 text-sm text-[#2D3A30]">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>;

export const Tag = ({ children, cls }) => <span className={`inline-block rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${cls}`}>{children}</span>;

export const Section = ({ icon: Icon, title, children, testid }) => (
  <section className="rounded-2xl border border-[#ddc69c]/70 bg-white p-5" data-testid={testid}>
    <h2 className="mb-3 flex items-center gap-2 font-serif text-[22px] font-semibold leading-tight text-[#0D2517]">
      <Icon size={22} className="shrink-0 text-[#B39257]" />{title}
    </h2>
    {children}
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc space-y-2 pl-5 text-[17px] leading-relaxed text-[#2D3A30]">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
);

export const SubTitle = ({ children }) => <h3 className="mb-2 mt-5 text-[18px] font-semibold text-[#0D2517] first:mt-0">{children}</h3>;
